import { render } from "./CardAuctionTime.vue?vue&type=template&id=698ae606&scoped=true"
import script from "./CardAuctionTime.vue?vue&type=script&lang=js"
export * from "./CardAuctionTime.vue?vue&type=script&lang=js"

import "@/Common/Styles/nftCard.scss?vue&type=style&index=0&id=698ae606&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/THEOS-interfaces/THEOS-interfaces/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-698ae606"]])

export default __exports__